module.exports = __webpack_public_path__ + "media/assets/img/products/studio_proofreading-not-selected-0b22845132147a9c16c8689a937a2e47.svg";